import React from 'react';
import {
  Button
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
  gallery_img: {
    width: '100%',
    height: '100%',
    maxWidth: '100%',
    objectFit: 'cover'
  },
  gallery_item: {
    margin: 0,
    position: 'relative',

    '& .title': {
      color: '#fff',
      position: 'absolute',
      fontWeight: '500',
      fontSize: '32px',
      lineHeight: '41px',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      textTransform: 'uppercase',
    },

    '& .mask': {
      visibility: 'hidden',
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',

      '& .mask_title': {
        color: '#fff',
        textTransform: 'uppercase',
        fontWeight: '500',
        fontSize: '28px',
      }
    },

    '&:hover .mask': {
      visibility: 'visible'
    }
  },
  gallery_item1: {
    gridColumnStart: 1,
    gridColumnEnd: 1,
    gridRowStart: 1,
    gridRowEnd: 3,

    '& .title': {
      top: '10px',
      left: '10px'
    },

    '& .mask': {
      padding: '40px'
    },

    '& .mask_categories': {
      fontWeight: 'normal',
      fontSize: '18px',
      lineHeight: '28px',
      textAlign: 'center',
      margin: '40px auto auto',
      color: '#fff',

      '& div': {
        marginBottom: '20px',
      }
    },
  },
  gallery_item2: {
    gridColumnStart: 2,
    gridColumnEnd: 4,
    gridRowStart: 1,
    gridRowEnd: 1,

    '& .title': {
      right: '10px',
      top: '10px'
    },

    '& .mask': {
      padding: '20px'
    },

    '& .mask_categories': {
      margin: 0,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignContent: 'space-evenly',
      height: '100%',
      width: '100%',
      fontWeight: 'normal',
      fontSize: '18px',
      lineHeight: '28px',
      color: '#fff',

      '& div': {
        textAlign: 'center',
        width: '50%'
      },

      '& div:nth-child(odd)': {
        borderRight: '1px solid #fff'
      }
    }
  },
  gallery_item3: {
    gridColumnStart: 2,
    gridColumnEnd: 4,
    gridRowStart: 2,
    gridRowEnd: 2,

    '& .title': {
      bottom: '10px',
      left: '10px'
    },

    '& .mask': {
      padding: '20px'
    },

    '& .mask_categories': {
      margin: 0,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignContent: 'space-evenly',
      height: '100%',
      width: '100%',
      fontWeight: 'normal',
      fontSize: '18px',
      lineHeight: '28px',
      color: '#fff',

      '& div': {
        textAlign: 'center',
        width: '50%'
      },

      '& div:nth-child(odd)': {
        borderRight: '1px solid #fff'
      }
    }
  },
  gallery_mobile_img: {
    width: '100%',
    height: '100%',
    maxHeight: '520px',
    maxWidth: '100%',
    objectFit: 'cover'
  },
  gallery_mobile_item: {
    margin: '0 0 20px',
    position: 'relative',
    height: '520px',

    '& .title': {
      color: '#fff',
      position: 'absolute',
      fontWeight: '500',
      fontSize: '32px',
      lineHeight: '41px',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      textTransform: 'uppercase',
    },

    '& .mask': {
      visibility: 'hidden',
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',

      '& .mask_title': {
        color: '#fff',
        textTransform: 'uppercase',
        fontWeight: '500',
        fontSize: '26px',
      }
    },

    '&:hover .mask': {
      visibility: 'visible'
    }
  },
  gallery_mobile_item1: {
    '& .title': {
      top: '10px',
      left: '10px'
    },

    '& .mask': {
      padding: '30px'
    },

    '& .mask_categories': {
      fontWeight: 'normal',
      fontSize: '16px',
      lineHeight: '28px',
      textAlign: 'center',
      margin: '40px auto auto',
      color: '#fff',

      '& div': {
        marginBottom: '5px',
      }
    },
  },
  gallery_mobile_item2: {
    '& .title': {
      right: '10px',
      top: '10px'
    },

    '& .mask': {
      padding: '20px'
    },

    '& .mask_categories': {
      fontWeight: 'normal',
      fontSize: '16px',
      lineHeight: '28px',
      textAlign: 'center',
      margin: '40px auto auto',
      color: '#fff',

      '& div': {
        marginBottom: '5px',
      }
    }
  },
  gallery_mobile_item3: {
    '& .title': {
      bottom: '10px',
      left: '10px'
    },

    '& .mask': {
      padding: '20px'
    },

    '& .mask_categories': {
      fontWeight: 'normal',
      fontSize: '16px',
      lineHeight: '28px',
      textAlign: 'center',
      margin: '40px auto auto',
      color: '#fff',

      '& div': {
        marginBottom: '5px',
      }
    }
  }
}));

const CTAPreviewImages = ({values, categories, mobileView}) => {
  const classes = useStyles();

  const getCategoryName = (id) => {
    if (!categories.length) {
      return '';
    }

    return categories.find((cat) => cat.id == id)?.name;
  };

  return (
    <>
      <figure
        className={`
              ${mobileView ? classes.gallery_mobile_item  : classes.gallery_item}
              ${mobileView ? classes.gallery_mobile_item1 : classes.gallery_item1}
            `}
      >
        <img
          src={
            mobileView
              ? values?.vertical['dermpro/design/cta_image_1_mobile']
              : values?.vertical['dermpro/design/cta_image_1_desktop']
          }
          className={mobileView ? classes.gallery_mobile_img : classes.gallery_img}
          alt="CTA 1"
        />
        <div className="title">
          {values?.vertical['store_info/cta/cta_vertical_title']}
        </div>
        <div className="mask">
          <div className="mask_title">
            {values?.vertical['store_info/cta/cta_vertical_mask_title']}
          </div>
          <div className="mask_categories">
            {(values?.vertical['store_info/cta/is_cta_vertical_mask_category_1'] == 1 &&
              values?.vertical['store_info/cta/cta_vertical_mask_categoryId_1'])
              ? <div>{getCategoryName(values?.vertical['store_info/cta/cta_vertical_mask_categoryId_1'])}</div>
              :
              <>
                {!!values?.vertical['store_info/cta/cta_vertical_mask_custom_link_title_1']?.length
                  && <div>{values?.vertical['store_info/cta/cta_vertical_mask_custom_link_title_1']}</div>
                }
              </>
            }
            {(values?.vertical['store_info/cta/is_cta_vertical_mask_category_2'] == 1 &&
              values?.vertical['store_info/cta/cta_vertical_mask_categoryId_2'])
              ? <div>{getCategoryName(values?.vertical['store_info/cta/cta_vertical_mask_categoryId_2'])}</div>
              :
              <>
                {!!values?.vertical['store_info/cta/cta_vertical_mask_custom_link_title_2']?.length
                  && <div>{values?.vertical['store_info/cta/cta_vertical_mask_custom_link_title_2']}</div>
                }
              </>
            }
            {(values?.vertical['store_info/cta/is_cta_vertical_mask_category_3'] == 1 &&
              values?.vertical['store_info/cta/cta_vertical_mask_categoryId_3'])
              ? <div>{getCategoryName(values?.vertical['store_info/cta/cta_vertical_mask_categoryId_3'])}</div>
              :
              <>
                {!!values?.vertical['store_info/cta/cta_vertical_mask_custom_link_title_3']?.length
                  && <div>{values?.vertical['store_info/cta/cta_vertical_mask_custom_link_title_3']}</div>
                }
              </>
            }
            {(values?.vertical['store_info/cta/is_cta_vertical_mask_category_4'] == 1 &&
              values?.vertical['store_info/cta/cta_vertical_mask_categoryId_4'])
              ? <div>{getCategoryName(values?.vertical['store_info/cta/cta_vertical_mask_categoryId_4'])}</div>
              :
              <>
                {!!values?.vertical['store_info/cta/cta_vertical_mask_custom_link_title_4']?.length
                  && <div>{values?.vertical['store_info/cta/cta_vertical_mask_custom_link_title_4']}</div>
                }
              </>
            }
            {(values?.vertical['store_info/cta/is_cta_vertical_mask_category_5'] == 1 &&
              values?.vertical['store_info/cta/cta_vertical_mask_categoryId_5'])
              ? <div>{getCategoryName(values?.vertical['store_info/cta/cta_vertical_mask_categoryId_5'])}</div>
              :
              <>
                {!!values?.vertical['store_info/cta/cta_vertical_mask_custom_link_title_5']?.length
                  && <div>{values?.vertical['store_info/cta/cta_vertical_mask_custom_link_title_5']}</div>
                }
              </>
            }
            {(values?.vertical['store_info/cta/is_cta_vertical_mask_category_6'] == 1 &&
              values?.vertical['store_info/cta/cta_vertical_mask_categoryId_6'])
              ? <div>{getCategoryName(values?.vertical['store_info/cta/cta_vertical_mask_categoryId_6'])}</div>
              :
              <>
                {!!values?.vertical['store_info/cta/cta_vertical_mask_custom_link_title_6']?.length
                  && <div>{values?.vertical['store_info/cta/cta_vertical_mask_custom_link_title_6']}</div>
                }
              </>
            }
          </div>
          <Button
            className="border-2-white border-radius-0 px-10 text-white bg-transparent hover-bg-gray"
            variant="outlined"
          >
            View All
          </Button>
        </div>
      </figure>
      <figure
        className={`
              ${mobileView ? classes.gallery_mobile_item  : classes.gallery_item}
              ${mobileView ? classes.gallery_mobile_item2 : classes.gallery_item2}
            `}
      >
        <img
          src={
            mobileView
              ? values?.horizontal_top['dermpro/design/cta_image_2_mobile']
              : values?.horizontal_top['dermpro/design/cta_image_2_desktop']
          }
          className={mobileView ? classes.gallery_mobile_img : classes.gallery_img}
          alt="CTA 2"
        />
        <div className="title">
          {values?.horizontal_top['store_info/cta/cta_horizontal_top_title']}
        </div>
        <div className="mask">
          <div className="mask_title">
            {values?.horizontal_top['store_info/cta/cta_horizontal_top_mask_title']}
          </div>
          <div className="mask_categories">
            {(values?.horizontal_top['store_info/cta/is_cta_horizontal_top_mask_category_1'] == 1 &&
              values?.horizontal_top['store_info/cta/cta_horizontal_top_mask_categoryId_1'])
              ? <div>{getCategoryName(values?.horizontal_top['store_info/cta/cta_horizontal_top_mask_categoryId_1'])}</div>
              :
              <>
                {!!values?.horizontal_top['store_info/cta/cta_horizontal_top_mask_custom_link_title_1']?.length
                  && <div>{values?.horizontal_top['store_info/cta/cta_horizontal_top_mask_custom_link_title_1']}</div>
                }
              </>
            }
            {(values?.horizontal_top['store_info/cta/is_cta_horizontal_top_mask_category_2'] == 1 &&
              values?.horizontal_top['store_info/cta/cta_horizontal_top_mask_categoryId_2'])
              ? <div>{getCategoryName(values?.horizontal_top['store_info/cta/cta_horizontal_top_mask_categoryId_2'])}</div>
              :
              <>
                {!!values?.horizontal_top['store_info/cta/cta_horizontal_top_mask_custom_link_title_2']?.length
                  && <div>{values?.horizontal_top['store_info/cta/cta_horizontal_top_mask_custom_link_title_2']}</div>
                }
              </>
            }
            {(values?.horizontal_top['store_info/cta/is_cta_horizontal_top_mask_category_3'] == 1 &&
              values?.horizontal_top['store_info/cta/cta_horizontal_top_mask_categoryId_3'])
              ? <div>{getCategoryName(values?.horizontal_top['store_info/cta/cta_horizontal_top_mask_categoryId_3'])}</div>
              :
              <>
                {!!values?.horizontal_top['store_info/cta/cta_horizontal_top_mask_custom_link_title_3']?.length
                  && <div>{values?.horizontal_top['store_info/cta/cta_horizontal_top_mask_custom_link_title_3']}</div>
                }
              </>
            }
            {(values?.horizontal_top['store_info/cta/is_cta_horizontal_top_mask_category_4'] == 1 &&
              values?.horizontal_top['store_info/cta/cta_horizontal_top_mask_categoryId_4'])
              ? <div>{getCategoryName(values?.horizontal_top['store_info/cta/cta_horizontal_top_mask_categoryId_4'])}</div>
              :
              <>
                {!!values?.horizontal_top['store_info/cta/cta_horizontal_top_mask_custom_link_title_4']?.length
                  && <div>{values?.horizontal_top['store_info/cta/cta_horizontal_top_mask_custom_link_title_4']}</div>
                }
              </>
            }
          </div>
          <Button
            className="border-2-white border-radius-0 px-10 text-white bg-transparent hover-bg-gray"
            variant="outlined"
          >
            View All
          </Button>
        </div>
      </figure>
      <figure
        className={`
              ${mobileView ? classes.gallery_mobile_item  : classes.gallery_item}
              ${mobileView ? classes.gallery_mobile_item3 : classes.gallery_item3}
            `}
      >
        <img
          src={
            mobileView
              ? values?.horizontal_bottom['dermpro/design/cta_image_3_mobile']
              : values?.horizontal_bottom['dermpro/design/cta_image_3_desktop']
          }
          className={mobileView ? classes.gallery_mobile_img : classes.gallery_img}
          alt="CTA 3"
        />
        <div className="title">
          {values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_title']}
        </div>
        <div className="mask">
          <div className="mask_title">
            {values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_mask_title']}
          </div>
          <div className="mask_categories">
            {(values?.horizontal_bottom['store_info/cta/is_cta_horizontal_bottom_mask_category_1'] == 1 &&
              values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_mask_categoryId_1'])
              ? <div>{getCategoryName(values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_mask_categoryId_1'])}</div>
              :
              <>
                {!!values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_mask_custom_link_title_1']?.length
                  && <div>{values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_mask_custom_link_title_1']}</div>
                }
              </>
            }
            {(values?.horizontal_bottom['store_info/cta/is_cta_horizontal_bottom_mask_category_2'] == 1 &&
              values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_mask_categoryId_2'])
              ? <div>{getCategoryName(values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_mask_categoryId_2'])}</div>
              :
              <>
                {!!values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_mask_custom_link_title_2']?.length
                  && <div>{values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_mask_custom_link_title_2']}</div>
                }
              </>
            }
            {(values?.horizontal_bottom['store_info/cta/is_cta_horizontal_bottom_mask_category_3'] == 1 &&
              values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_mask_categoryId_3'])
              ? <div>{getCategoryName(values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_mask_categoryId_3'])}</div>
              :
              <>
                {!!values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_mask_custom_link_title_3']?.length
                  && <div>{values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_mask_custom_link_title_3']}</div>
                }
              </>
            }
            {(values?.horizontal_bottom['store_info/cta/is_cta_horizontal_bottom_mask_category_4'] == 1 &&
              values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_mask_categoryId_4'])
              ? <div>{getCategoryName(values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_mask_categoryId_4'])}</div>
              :
              <>
                {!!values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_mask_custom_link_title_4']?.length
                  && <div>{values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_mask_custom_link_title_4']}</div>
                }
              </>
            }
          </div>
          <Button
            className="border-2-white border-radius-0 px-10 text-white bg-transparent hover-bg-gray"
            variant="outlined"
          >
            View All
          </Button>
        </div>
      </figure>
    </>
  );
};

export default CTAPreviewImages;
